"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useLocalStorage_1 = require("./useLocalStorage");
Object.defineProperty(exports, "useLocalStorage", { enumerable: true, get: function () { return useLocalStorage_1.default; } });
